import { Button } from "antd";
import { useState } from "react";
import OrderDetail from "./OrderDetail";

const OrderTable = ({ data }) => {
  const [open, setOpen] = useState(false);
  const [orderId, setOrderId] = useState('');

  return (
    <div className="table-container w-full">
      <table className="table-auto w-full border-collapse border-[1px] border-[#E8E8E8]">
        <thead
          className="bg-[#F7F7F7] rounded-[8px] text-[14px] font-dmsans text-[#787389] font-medium"
          style={{
            position: "sticky",
            top: "0",
          }}
        >
          <tr className="">
            {/* <th className="py-2 px-2 text-start">Tracking ID</th> */}
            <th className="py-2 px-2 text-start">Customer</th>
            <th className="py-2 px-2 text-start">Items</th>
            <th className="py-2 px-2 text-start">Order date</th>
            <th className="py-2 px-2 text-start">Total Amount</th>
            <th className="py-2 px-2 text-start">Status</th>
            <th className="py-2 px-2 text-start"></th>
          </tr>
        </thead>
        <tbody>
          {(data || []).map((v, k) => {
            return (
              <tr key={k} className="text-[#787389] font-dmsans text-[15px]">
                {/* <td className="py-2 px-3 border-b-[1px]">#874640</td> */}
                <td className="py-2 px-3 border-b-[1px] font-medium">
                  <div className="inline-flex items-center gap-2">
                    <div className="h-6 w-6 rounded-full bg-black"></div>
                    {v.userId?.firstName} {v.userId?.lastName}
                  </div>
                </td>
                <td className="py-2 px-3 border-b-[1px] text-[#2D9CDB]">
                  {v?.itemsCount || v?.items?.length > 1
                    ? `${v?.itemsCount || v?.items?.length} items`
                    : `${v?.itemsCount || v?.items?.length} item`}
                </td>
                <td className="py-2 px-3 border-b-[1px]">
                  {new Date(v.createdAt).toLocaleDateString()}{" "}
                </td>
                <td className="py-2 px-3 border-b-[1px] text-dark font-bold">
                  N {Number(v.total || 0).toLocaleString()}
                </td>
                <td
                  className={`py-2 px-3 border-b-[1px] capitalize ${
                    v.status === "pending"
                      ? "text-orange-500"
                      : v.status === "cancelled"
                      ? "text-red-600"
                      : v.status === "completed"
                      ? "text-green-700"
                      : "text-yellow-600"
                  }`}
                >
                  {v.status}
                </td>
                <td>
                  <Button type="primary" onClick={() => {
                    setOpen(true);
                    setOrderId(v.id)
                  }}>
                    View
                  </Button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {open && <OrderDetail open={open} onClose={() => setOpen(false)} id={orderId} />}
    </div>
  );
};

export default OrderTable;
